import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  FaAndroid,
  FaBookOpen,
  FaChevronRight,
  FaEnvelope,
  FaExternalLinkAlt,
  FaGlobe,
  FaHeart,
  FaIdCard,
  FaLayerGroup,
  FaPhone,
  FaShieldAlt,
  FaTimes,
  FaTrophy,
  FaUserTie,
} from "react-icons/fa";

const DEVELOPER_PROFILE = {
  name: "Laurent VICTORIN",
  role: "Développeur Web & Web Mobile · Président & Enseignant de Judo",
  email: "monappliclub@gmail.com",
  phoneDisplay: "06 80 72 77 07",
  phoneHref: "+33680727707",
  photo:
    "https://res.cloudinary.com/dj0c0zuje/image/upload/v1744184384/PXL_20241115_211013575.MP_1_h7lbn9.jpg",
  website: "https://www.monappliclub.com/",
  vkard:
    "https://profile.vkard.io/8f8e4d95-cf28-40b0-afc6-2ec677889d49/ab099714aa",
};

const DONATION_LINKS = [
  {
    label: "5 €",
    subtitle: "Don unique pour soutenir le développement",
    url: "https://buy.stripe.com/cN2aFtaqL5fC1AkcMR",
  },
];

const PRODUCT_LINKS = [
  {
    label: "MonAppliClub Standard",
    description: "Site & gestion pour clubs sportifs",
    href: "https://www.monappliclub-demo.com",
    icon: FaGlobe,
  },
  {
    label: "MonAppliClub Light",
    description: "Version vitrine simplifiée",
    href: "https://www.monappliclub-demo-light.com",
    icon: FaGlobe,
  },
  {
    label: "MonAppliComité",
    description: "Exemple comité départemental",
    href: "https://www.judogironde.fr/",
    icon: FaLayerGroup,
  },
  {
    label: "MonAppliAsso",
    description: "Club multisports",
    href: "https://www.monappliasso.com/",
    icon: FaLayerGroup,
  },
  {
    label: "Judo Présence Pro",
    description: "Application pour le suivi des présences en club de judo",
    href: "https://judo-presence-pro.com/",
    icon: FaLayerGroup,
  },
  {
    label: "MonAppliKata",
    description: "Recherche de partenaires kata",
    href: "https://www.monappliclub.com/partenaires-kata",
    icon: FaBookOpen,
  },
  {
    label: "Judo Score Pro",
    description: "Application Android de scoring judo",
    href: "https://play.google.com/store/apps/details?id=com.victorin.judoscorepro",
    icon: FaAndroid,
  },
];

const FOOTER_FEATURES = [
  {
    label: "Techniques",
    description: "Favoris, traductions, vidéos et informations techniques.",
    icon: FaBookOpen,
  },
  {
    label: "Progression",
    description: "Suivi des grades, palmarès et carnet du judoka.",
    icon: FaTrophy,
  },
  {
    label: "Club & coach",
    description: "Un outil pensé par un enseignant de judo pour les judokas.",
    icon: FaShieldAlt,
  },
];

const LEGAL_LINKS = [
  {
    label: "Mentions légales",
    to: "/mentions-legales",
  },
  {
    label: "Politique de confidentialité",
    to: "/politique-confidentialite",
  },
  {
    label: "Conditions d’utilisation",
    to: "/conditions-utilisation",
  },
];

const FooterLink = ({ children, to }) => (
  <Link
    to={to}
    className="group inline-flex items-center gap-2 text-sm font-semibold text-slate-300 transition hover:text-orange-300"
  >
    <span>{children}</span>
    <span className="h-1 w-1 rounded-full bg-orange-400 opacity-0 transition group-hover:opacity-100" />
  </Link>
);

const ExternalProductLink = ({ item, index }) => {
  const Icon = item.icon || FaExternalLinkAlt;

  return (
    <a
      href={item.href}
      target="_blank"
      rel="noopener noreferrer"
      className="group relative overflow-hidden rounded-[1.35rem] border border-white/10 bg-white/[0.04] p-4 transition hover:-translate-y-0.5 hover:border-orange-400/40 hover:bg-white/[0.08] sm:p-5"
    >
      <div className="absolute inset-y-0 left-0 w-1 bg-gradient-to-b from-blue-500 via-indigo-500 to-orange-400 opacity-70 transition group-hover:opacity-100" />

      <div className="flex items-start gap-4 pl-1">
        <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-white text-blue-700 shadow-lg transition group-hover:scale-105 sm:h-13 sm:w-13">
          <Icon />
        </div>

        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
            <p className="text-base font-bold leading-snug text-white sm:text-lg">
              {item.label}
            </p>

            <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-orange-400/10 text-orange-300 transition group-hover:bg-orange-400 group-hover:text-white">
              <FaExternalLinkAlt className="text-[10px]" />
            </span>
          </div>

          <p className="mt-1.5 text-sm font-medium leading-6 text-slate-400">
            {item.description}
          </p>
        </div>

        <span className="hidden rounded-full border border-white/10 bg-white/[0.04] px-2.5 py-1 text-[10px] font-bold text-slate-400 lg:inline-flex">
          0{index + 1}
        </span>
      </div>
    </a>
  );
};

const FeatureCard = ({ item }) => {
  const Icon = item.icon;

  return (
    <div className="rounded-[1.35rem] border border-white/10 bg-white/[0.04] p-4">
      <div className="flex items-start gap-3">
        <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-600 to-orange-400 text-white shadow-lg shadow-blue-950/30">
          <Icon />
        </div>

        <div>
          <p className="text-sm font-bold text-white">{item.label}</p>
          <p className="mt-1 text-xs font-medium leading-5 text-slate-400">
            {item.description}
          </p>
        </div>
      </div>
    </div>
  );
};

const DeveloperPanel = ({ open, onClose }) => {
  const donation = DONATION_LINKS[0];

  useEffect(() => {
    if (!open) return undefined;

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", onKeyDown);

    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[90] flex items-end justify-center p-3 sm:p-5">
      <button
        type="button"
        aria-label="Fermer le panneau développeur"
        className="absolute inset-0 bg-slate-950/60 backdrop-blur-sm"
        onClick={onClose}
      />

      <aside className="relative max-h-[calc(100dvh-1.5rem)] w-full max-w-3xl overflow-y-auto rounded-[1.7rem] border border-white/10 bg-slate-950 text-white shadow-2xl overscroll-contain sm:max-h-[calc(100dvh-2.5rem)] sm:rounded-[2rem]">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(249,115,22,0.20),transparent_36%),radial-gradient(circle_at_bottom_right,rgba(37,99,235,0.18),transparent_34%)]" />

        <div className="relative p-4 sm:p-6">
          <button
            type="button"
            onClick={onClose}
            className="absolute right-3 top-3 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-white text-slate-950 shadow-lg transition hover:scale-105 sm:right-4 sm:top-4"
            aria-label="Fermer"
          >
            <FaTimes className="text-sm" />
          </button>

          <div className="flex gap-4 pr-10">
            <div className="h-16 w-16 shrink-0 overflow-hidden rounded-2xl bg-white shadow-xl sm:h-20 sm:w-20">
              <img
                src={DEVELOPER_PROFILE.photo}
                alt={DEVELOPER_PROFILE.name}
                className="h-full w-full object-cover"
              />
            </div>

            <div className="min-w-0">
              <p className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-white/60 sm:text-xs">
                <FaUserTie className="text-orange-300" />
                Créateur
              </p>

              <h3 className="mt-3 font-titre text-2xl font-bold leading-tight text-white sm:text-3xl">
                {DEVELOPER_PROFILE.name}
              </h3>

              <p className="mt-1 text-xs font-semibold leading-5 text-white/60 sm:text-sm sm:leading-6">
                {DEVELOPER_PROFILE.role}
              </p>
            </div>
          </div>

          <div className="mt-5 rounded-[1.4rem] border border-white/10 bg-white/5 p-4 backdrop-blur-xl sm:rounded-[1.7rem] sm:p-5">
            <p className="inline-flex items-center gap-2 rounded-full border border-orange-500/20 bg-orange-500/10 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-orange-300 sm:text-xs">
              <FaHeart />
              Soutenir le projet
            </p>

            <h4 className="mt-3 font-titre text-2xl font-bold leading-tight text-white sm:text-3xl">
              Des outils numériques créés pour les clubs et les judokas.
            </h4>

            <p className="mt-3 text-sm leading-6 text-white/70 sm:leading-7">
              Judo Coach Pro s’inscrit dans l’écosystème MonAppliClub : des
              applications simples, modernes et utiles pour accompagner les
              clubs sportifs, les enseignants et les pratiquants au quotidien.
            </p>

            <div className="mt-5 grid grid-cols-2 gap-2 sm:grid-cols-4">
              <a
                href={`mailto:${DEVELOPER_PROFILE.email}`}
                className="inline-flex items-center justify-center gap-2 rounded-full border border-white/10 bg-white/10 px-3 py-2.5 text-xs font-bold text-white transition hover:bg-white hover:text-slate-950 sm:text-sm"
              >
                <FaEnvelope />
                Email
              </a>

              <a
                href={`tel:${DEVELOPER_PROFILE.phoneHref}`}
                className="inline-flex items-center justify-center gap-2 rounded-full border border-white/10 bg-white/10 px-3 py-2.5 text-xs font-bold text-white transition hover:bg-white hover:text-slate-950 sm:text-sm"
              >
                <FaPhone />
                Appeler
              </a>

              <a
                href={DEVELOPER_PROFILE.website}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-white/10 bg-white/10 px-3 py-2.5 text-xs font-bold text-white transition hover:bg-white hover:text-slate-950 sm:text-sm"
              >
                <FaGlobe />
                Site
              </a>

              <a
                href={DEVELOPER_PROFILE.vkard}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 rounded-full border border-white/10 bg-white/10 px-3 py-2.5 text-xs font-bold text-white transition hover:bg-white hover:text-slate-950 sm:text-sm"
              >
                <FaIdCard />
                VCard
              </a>
            </div>

            {donation && (
              <div className="mt-5 flex flex-col gap-3 rounded-[1.4rem] border border-orange-500/20 bg-orange-500/10 p-4 sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <p className="font-titre text-xl font-bold text-white sm:text-2xl">
                    Faire un don de {donation.label}
                  </p>

                  <p className="mt-1 text-xs font-semibold leading-5 text-orange-200/80 sm:text-sm">
                    {donation.subtitle}
                  </p>
                </div>

                <a
                  href={donation.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-3 rounded-full bg-orange-500 px-5 py-3 text-sm font-bold text-white shadow-[0_18px_45px_rgba(249,115,22,0.28)] transition hover:-translate-y-0.5 hover:brightness-110"
                >
                  <FaHeart />
                  Soutenir
                </a>
              </div>
            )}
          </div>
        </div>
      </aside>
    </div>
  );
};

function Footer() {
  const [developerPanelOpen, setDeveloperPanelOpen] = useState(false);

  const currentYear = useMemo(() => new Date().getFullYear(), []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <footer className="relative overflow-hidden bg-slate-950 text-white font-satoshi">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(249,115,22,0.20),transparent_34%),radial-gradient(circle_at_bottom_right,rgba(37,99,235,0.18),transparent_32%)]" />

        <div className="absolute inset-0 bg-[linear-gradient(to_right,rgba(255,255,255,0.07)_1px,transparent_1px),linear-gradient(to_bottom,rgba(255,255,255,0.07)_1px,transparent_1px)] bg-[size:42px_42px] opacity-20" />

        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-orange-400/80 to-transparent" />

        <div className="relative mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8 lg:py-18">
          <div className="grid gap-8 xl:grid-cols-[0.95fr_1.45fr_0.75fr]">
            <div className="flex flex-col justify-between rounded-[2rem] border border-white/10 bg-white/5 p-6 shadow-2xl backdrop-blur-xl sm:p-7">
              <div>
                <button
                  type="button"
                  onClick={scrollToTop}
                  className="group flex items-center gap-4 text-left"
                >
                  <div className="flex h-24 w-24 shrink-0 items-center justify-center overflow-hidden rounded-[1.7rem] bg-white p-2 shadow-xl transition group-hover:-translate-y-1 sm:h-28 sm:w-28">
                    <img
                      src="/img/logo_judocoach_pro_512.png"
                      alt="Logo Judo Coach Pro"
                      className="h-full w-full object-contain"
                      loading="lazy"
                    />
                  </div>

                  <div className="min-w-0">
                    <p className="text-xs font-bold uppercase tracking-[0.22em] text-slate-500">
                      Carnet digital du judoka
                    </p>

                    <h2 className="mt-1 font-titre text-3xl font-bold leading-tight text-white">
                      Judo Coach <span className="text-orange-400">Pro</span>
                    </h2>
                  </div>
                </button>

                <p className="mt-6 text-sm leading-7 text-slate-400">
                  Techniques, favoris, palmarès, passages de grade et outils de
                  progression : une application pensée pour accompagner le
                  judoka et son enseignant au quotidien.
                </p>
              </div>

              <div className="mt-7 grid gap-3">
                {FOOTER_FEATURES.map((item) => (
                  <FeatureCard key={item.label} item={item} />
                ))}
              </div>
            </div>

            <div className="rounded-[2rem] border border-white/10 bg-white/5 p-6 shadow-2xl backdrop-blur-xl sm:p-7">
              <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
                <div>
                  <p className="text-xs font-bold uppercase tracking-[0.22em] text-orange-300">
                    Écosystème MonAppliClub
                  </p>

                  <h3 className="mt-2 font-titre text-3xl font-bold leading-tight text-white">
                    Mes applications Judo 🥋
                  </h3>
                </div>

                <a
                  href="https://www.monappliclub.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex min-h-11 items-center justify-center gap-2 rounded-full border border-white/10 bg-white/10 px-4 py-2 text-sm font-bold text-white transition hover:bg-white hover:text-slate-950"
                >
                  MonAppliClub
                  <FaExternalLinkAlt className="text-[10px]" />
                </a>
              </div>

              <p className="mt-4 text-sm leading-7 text-slate-400">
                Une suite d’outils web et mobiles créés pour les clubs de judo,
                les comités, les enseignants et les organisateurs.
              </p>

              <nav className="mt-6 grid gap-3 [grid-template-columns:repeat(auto-fit,minmax(min(100%,20rem),1fr))]">
                {PRODUCT_LINKS.map((item, index) => (
                  <ExternalProductLink
                    key={item.label}
                    item={item}
                    index={index}
                  />
                ))}
              </nav>
            </div>

            <div className="grid gap-6 sm:grid-cols-2 xl:grid-cols-1">
              <div className="rounded-[2rem] border border-white/10 bg-white/5 p-6 shadow-2xl backdrop-blur-xl sm:p-7">
                <h3 className="font-titre text-2xl font-bold text-white">
                  Informations
                </h3>

                <nav className="mt-5 flex flex-col items-start gap-3">
                  {LEGAL_LINKS.map((link) => (
                    <FooterLink key={link.to} to={link.to}>
                      {link.label}
                    </FooterLink>
                  ))}
                </nav>
              </div>

              <div className="rounded-[2rem] border border-white/10 bg-white/5 p-6 shadow-2xl backdrop-blur-xl sm:p-7">
                <p className="inline-flex items-center gap-2 rounded-full border border-blue-400/20 bg-blue-500/10 px-3 py-1 text-xs font-bold uppercase tracking-[0.16em] text-blue-200">
                  <FaUserTie />
                  Créateur
                </p>

                <h3 className="mt-4 font-titre text-2xl font-bold leading-tight text-white">
                  Un projet développé par un passionné de judo.
                </h3>

                <p className="mt-3 text-sm leading-7 text-slate-400">
                  Découvrez le créateur de Judo Coach Pro et les autres outils
                  développés autour de MonAppliClub.
                </p>

                <button
                  type="button"
                  onClick={() => setDeveloperPanelOpen(true)}
                  className="mt-5 inline-flex min-h-12 w-full items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-blue-600 to-orange-500 px-5 py-3 text-sm font-bold text-white shadow-lg shadow-orange-500/20 transition hover:-translate-y-0.5 active:translate-y-0"
                >
                  Voir le profil
                  <FaChevronRight className="text-xs" />
                </button>
              </div>
            </div>
          </div>

          <div className="mt-10 flex flex-col gap-4 rounded-[2rem] border border-white/10 bg-black/25 px-5 py-5 text-center text-sm text-slate-400 backdrop-blur-xl md:flex-row md:items-center md:justify-between md:text-left">
            <p>
              Copyright © {currentYear} - Tous droits réservés -{" "}
              <span className="font-semibold text-white">Judo Coach Pro</span>
            </p>

            <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2">
              <a
                href="https://www.monappliclub.com"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 font-semibold text-white transition hover:text-orange-300"
              >
                MonAppliClub
                <FaExternalLinkAlt className="text-[10px]" />
              </a>

              <button
                type="button"
                onClick={() => setDeveloperPanelOpen(true)}
                className="inline-flex items-center gap-2 font-semibold text-white transition hover:text-orange-300"
              >
                Laurent VICTORIN
                <FaHeart className="text-[11px]" />
              </button>
            </div>
          </div>
        </div>
      </footer>

      <DeveloperPanel
        open={developerPanelOpen}
        onClose={() => setDeveloperPanelOpen(false)}
      />
    </>
  );
}

export default Footer;
